<template>
    <router-view />

</template>

<script>
export default {
    created() {
        this.$store.dispatch('app/init')
    }
};
</script>

<style>
@import "./assets/css/main.css";
@import "./assets/css/color-dark.css";
@import "./styles/var.css";
@import "./assets/css/dark-mode.css";
</style>